module.exports = __webpack_public_path__ + "static/media/drag.d8d6035a.png";